import {AsyncPipe, CurrencyPipe, DecimalPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormControl, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators,} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle,} from '@angular/material/card';
import {MatDialog} from '@angular/material/dialog';
import {MatDivider} from '@angular/material/divider';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatList, MatListItem, MatListItemIcon} from '@angular/material/list';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';
import {BillingService} from '@app/admin/billing.service';
import {Client, ClientService} from '@app/admin/client.service';
import {UpgradeData,} from '@app/landing/upgrade-dialog/upgrade-dialog.component';
import {ManagedComponent} from '@app/shared/managed.component';
import {Observable, tap} from 'rxjs';
import {ToolbarComponent} from '../toolbar/toolbar.component';

export const Discount = 0.84;
export const UserCost = 12;

export const Prices = {
    user: [12, 10],
};

export enum Interval {
    Month,
    Annual,
}

@Component({
    selector: 'frog-upgrade',
    templateUrl: './upgrade.component.html',
    styleUrls: ['./upgrade.component.scss'],
    imports: [
        ToolbarComponent,
        ReactiveFormsModule,
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardSubtitle,
        MatCardContent,
        MatList,
        MatListItem,
        MatIcon,
        MatListItemIcon,
        MatDivider,
        MatRadioGroup,
        MatRadioButton,
        MatFormField,
        MatLabel,
        MatInput,
        MatButton,
        AsyncPipe,
        DecimalPipe,
        CurrencyPipe,
    ],
})
export class UpgradeComponent extends ManagedComponent implements OnInit {
    public form: UntypedFormGroup;
    public promoControl: FormControl;
    public userPrice: number;
    public total: number;
    public subtotal: number;
    public error: string;
    public discount: any;
    public client$: Observable<Client>;
    public pricing$: Observable<any>;

    constructor(
        private clientService: ClientService,
        private billingService: BillingService,
        private formBuilder: UntypedFormBuilder,
        private matDialog: MatDialog,
    ) {
        super();
        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            email: ['', Validators.required],
            interval: 'annual',
            annual: true,
            seats: 1,
        });
        this.promoControl = new FormControl();

        const sub = this.form.valueChanges.subscribe(() => this.formChanges());
        this.subscriptions.push(sub);

        this.userPrice = Prices.user[Interval.Month];
    }

    ngOnInit(): void {
        this.client$ = this.clientService.get().pipe(
            tap((client) => {
                this.form.patchValue({
                    seats: client.paid_members,
                    storage: 50,
                });
            }),
        );
        this.pricing$ = this.billingService.pricing();
    }

    submit() {
        const upgradeData = new UpgradeData();
        upgradeData.seats = this.form.value.seats;
        upgradeData.interval =
            this.form.value.interval === 'annual' ? Interval.Annual : Interval.Month;
        upgradeData.promo = this.promoControl.value;

        const options = {
            seats: upgradeData.seats,
            interval: upgradeData.interval,
            promo: upgradeData.promo,
            withCredentials: true,
        };
        this.billingService.createSubscription(options).subscribe((url) => {
            window.location = url;
        });
    }

    applyPromo() {
        this.formChanges();
    }

    private formChanges() {
        const value = this.form.value;
        const interval = value.interval === 'annual' ? Interval.Annual : Interval.Month;

        this.billingService
            .invoicePreview(value.seats, interval, this.promoControl.value)
            .subscribe((response) => {
                this.total = response.total / 100.0;
                this.subtotal = response.subtotal / 100.0;
                this.userPrice = response.unit_amount / 100.0;
                this.error = response.error;
                this.discount = response.discount;
            });
    }
}
